import type { AppState } from '@capacitor/app'
import mitt from 'mitt'

type Events = {
  appScroll: HTMLElement
  windowResize: undefined
  docContentClicked: undefined
  headerScrollUpdate: undefined
  showActionMenu: undefined
  overlayMenuOpened: undefined
  overlayMenuClosed: undefined
  closeOverlayMenu: undefined
  logoutOfflineFailure: undefined
  openSortPopup: undefined
  toggleNightMode: undefined
  docContentSelectionStarted: undefined
  showBookControlBar: undefined
  closeInAppBrowser16218: undefined
  stripeFinishedLoading: undefined
  hesitationPopupOpen18997: undefined
  hesitationPopupClose18997: undefined
  exitIntentPopupOpen19129: undefined
  appVisibilityChange: AppState
  checklistShowPopup: undefined
}

export const emitter = mitt<Events>()
